<template>
  <div class="dss-other-medication">
    <div class="dss__subheader">
      <div class="dss__subheader-main mb-6 mt-5">
        <smart-icon icon="mdi-heart-off-outline" size="16" class="mr-2" />
        <h3>{{ $ucfirst($t("dss.currentPrescription")) }}</h3>
      </div>
    </div>

    <medication
        v-for="(otherMedicationSchedulesWithRecommendationInfo, index) in otherMedicationSchedulesWithRecommendationInfo"
        :key="`schedule-${otherMedicationSchedulesWithRecommendationInfo.medicationSchedule.id}`"
        :index="index"
        :value="otherMedicationSchedulesWithRecommendationInfo.medicationSchedule"
        :has-medication-class="false"
        :has-notes="false"
        :has-history="false"
        :has-recommendation-info="false"
        is-read-only
        single-class
        :medicationSchedulesWithRecommendationInfo="otherMedicationSchedulesWithRecommendationInfo"
        :showPatientIcon="true"
        @input="(medication) => submitMedication(medication, index)"
        @remove="(id) => removeMedication(id, index)"
    ></medication>

    <div
      v-if="!otherMedicationSchedulesWithRecommendationInfo.length"
      class="medication-list__empty mb-6"
    >{{ $ucfirst($t('patient.medicationListEmpty')) }}</div>
  </div>
</template>

<script>
import Medication from '../../components/Parts/Medication/Medication';
import SmartIcon from "../../components/Parts/SmartIcon.vue";

import { mapGetters } from "vuex";

/**
 * Component DSSOtherMedication.vue
 *
 * @module DSSOtherMedication
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.10] app/src/APP_DASHBOARD/templates/views/DSS/DSSOtherMedication.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "DSSOtherMedication",
  components: {
    Medication,
    SmartIcon,
  },
  created() {
    this.$app.eventBus.$on('DSSHeader.saveAndExit', this.saveAndExit)
  },
  beforeDestroy(){
    this.$app.eventBus.$off('DSSHeader.saveAndExit', this.saveAndExit)
  },
  methods: {
    saveAndExit: function(){
      this.$router.push({name: 'DSSMedicationPrescription'})
    }
  },
  computed: {
    ...mapGetters({
      otherMedicationSchedulesWithRecommendationInfo: 'dss/otherMedicationSchedulesWithRecommendationInfo',
    }),
  },
};
</script>

<style lang="scss">
.medication-list__empty {
  background-color: #f6f6f6;
  border-radius: 16px;
  width: 100%;
  height: 282px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
}

.medication__icon {
  height: 24px;
}
</style>
